/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Demand_LocalityInputs */

const cs_public_site_demand_locality = /** @type {(inputs: Public_Site_Demand_LocalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalita`)
};

const en_public_site_demand_locality = /** @type {(inputs: Public_Site_Demand_LocalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locality`)
};

/**
* | output |
* | --- |
* | "Locality" |
*
* @param {Public_Site_Demand_LocalityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_demand_locality = /** @type {((inputs?: Public_Site_Demand_LocalityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Demand_LocalityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_demand_locality(inputs)
	return cs_public_site_demand_locality(inputs)
});